import pageableFactory from '@/store/modules/mixins/pageable';
import crudableFactory from '@/store/modules/mixins/crudable';

const pageable = pageableFactory();
const crudable = crudableFactory();
const defaultState = () => ({
  ...pageable.state,
  ...crudable.state,
});

const usersModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    ...pageable.mutations,
    ...crudable.mutations,
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    CREATE: crudable.actions.createPartialApplication({
      uriRoot: 'allowlist',
      name: 'ip',
      props: {
        alias: 'alias',
        ip_start: 'ip_start',
        ip_end: 'ip_end',
      },
      isSingular: false,
    }),
    DELETE: crudable.actions.deletePartialApplication({ uriRoot: 'allowlist', name: 'ip' }),
    PAGINATE: pageable.actions.paginatePartialApplication({
      url: 'allowlist',
    }),
  },
  getters: {
    ...pageable.getters,
  },
};

export default usersModule;
